// Registers /service-worker.js (see client/public/service-worker.js).
// Production builds only — in dev the SW would fight CRA's dev server and
// hot reload. There is no forced skipWaiting/reload: a new version activates
// when all tabs close, and navigations are network-first anyway, so users
// on payroll screens are never reloaded mid-edit.

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (
              installing.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              console.log(
                'SHIFT: גרסה חדשה זמינה — תיטען בפתיחה הבאה של האפליקציה'
              );
            }
          };
        };
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}

// Emergency escape hatch: swap register() for unregister() in index.js and
// deploy to remove the service worker from all clients.
export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
